import Splide from '@splidejs/splide';

const ISMOBILE = window.matchMedia("only screen and (max-width: 768px)").matches
const EL = '.js-show-videos'
const ELS = document.querySelectorAll(EL);

if(!ISMOBILE){
  ELS.forEach((EL) => {
    new Splide( EL, {
      perMove: 1,
      pagination: false,
      gap: '30px',
      fixedWidth: '580px',
      breakpoints: {
        '768': {
          fixedWidth: '240px',
          gap: '20px',
        },
      },
    } ).mount();
  });
}
